// components/Composite/JoinUs/JoinUs.js
import React from 'react';
import PropTypes from 'prop-types';
import { AccordionItem } from '../../Molecules';

const JoinUs = ({ value }) => {
  const {
    heading,
    intro,
    benefits_title,
    benefits = [],
    cta_title,
    cta_description,
    cta,
    faq_title,
    faqs = [],
  } = value;

  return (
    <section className="section section-default-width">
      <div className="section__inner">

        {/* Page header — heading + intro */}
        {(heading || intro) && (
          <div className="section__header block-align-center">
            {heading && (
              <div className="text-section-title">{heading}</div>
            )}
            {intro && (
              <div className="text-lead">{intro}</div>
            )}
          </div>
        )}

        <div className="section__body">

          {/* Benefits */}
          {benefits.length > 0 && (
            <div className="block">
              {benefits_title && (
                <div className="block__header block-align-center">
                  <div className="text-block-title">{benefits_title}</div>
                </div>
              )}
              <div className="block__body">
                <div className="grid-2 grid-gap-normal">
                  {benefits.map((benefit, index) => (
                    <div key={index} className="card card-data surface-pad-normal">
                      <div className="block">
                        <div className="block__body stack stack-normal">
                          <div className="text-item-title">{benefit.title}</div>
                          {benefit.description && (
                            <div className="text-body">{benefit.description}</div>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* CTA */}
          {(cta_title || cta_description || cta) && (
            <div className="block block-align-center">
              <div className="block__body stack stack-normal">
                {cta_title && (
                  <div className="text-block-title">{cta_title}</div>
                )}
                {cta_description && (
                  <div className="text-lead">{cta_description}</div>
                )}
                {cta && (cta.cta_page?.url || cta.cta_url) && (
                  <div className="cluster cluster-center">
                    <a
                      href={cta.cta_page?.url || cta.cta_url}
                      className="btn btn-primary btn-lg"
                    >
                      {cta.text || 'Join Fommes'}
                    </a>
                  </div>
                )}
              </div>
            </div>
          )}

          {/* FAQ */}
          {faqs.length > 0 && (
            <div className="block">
              {faq_title && (
                <div className="block__header block-align-center">
                  <div className="text-block-title">{faq_title}</div>
                </div>
              )}
              <div className="block__body">
                <div className="stack stack-normal">
                  {faqs.map((faq, index) => (
                    <AccordionItem
                      key={index}
                      question={faq.question}
                      answer={faq.answer}
                    />
                  ))}
                </div>
              </div>
            </div>
          )}

        </div>
      </div>
    </section>
  );
};

JoinUs.propTypes = {
  value: PropTypes.shape({
    heading: PropTypes.string,
    intro: PropTypes.string,
    benefits_title: PropTypes.string,
    benefits: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string.isRequired,
        description: PropTypes.string,
      })
    ),
    cta_title: PropTypes.string,
    cta_description: PropTypes.string,
    cta: PropTypes.shape({
      text: PropTypes.string,
      cta_page: PropTypes.shape({ url: PropTypes.string }),
      cta_url: PropTypes.string,
    }),
    faq_title: PropTypes.string,
    faqs: PropTypes.arrayOf(
      PropTypes.shape({
        question: PropTypes.string.isRequired,
        answer: PropTypes.string.isRequired,
      })
    ),
  }).isRequired,
};

export default JoinUs;